// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/form.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
/**
 * Describes the file vitesse/v1/form.proto.
 */
export const file_vitesse_v1_form = /*@__PURE__*/ fileDesc("ChV2aXRlc3NlL3YxL2Zvcm0ucHJvdG8SCnZpdGVzc2UudjEiwQEKCUZvcm1GaWVsZBILCgNrZXkYASABKAkSLQoJY29tcG9uZW50GAIgASgOMhoudml0ZXNzZS52MS5GaWVsZENvbXBvbmVudBINCgVsYWJlbBgDIAEoCRIQCghyZXF1aXJlZBgEIAEoCBIPCgdkZWZhdWx0GAUgASgJEhMKC3BsYWNlaG9sZGVyGAYgASgJEgwKBGhlbHAYByABKAkSEgoKdmFsaWRhdGlvbhgIIAEoCRIPCgdvcHRpb25zGAkgAygJIjMKCkZvcm1TY2hlbWESJQoGZmllbGRzGAEgAygLMhUudml0ZXNzZS52MS5Gb3JtRmllbGQq7wEKDkZpZWxkQ29tcG9uZW50Eh8KG0ZJRUxEX0NPTVBPTkVOVF9VTlNQRUNJRklFRBAAEhgKFEZJRUxEX0NPTVBPTkVOVF9URVhUEAESGgoWRklFTERfQ09NUE9ORU5UX05VTUJFUhACEhoKFkZJRUxEX0NPTVBPTkVOVF9TRUxFQ1QQAxIZChVGSUVMRF9DT01QT05FTlRfUkFESU8QBBIaChZGSUVMRF9DT01QT05FTlRfVE9HR0xFEAUSGgoWRklFTERfQ09NUE9ORU5UX1NFQ1JFVBAGEhcKE0ZJRUxEX0NPTVBPTkVOVF9QRU0QB0KuAQoOY29tLnZpdGVzc2UudjFCCUZvcm1Qcm90b1ABWkhnaXRodWIuY29tL01vdmVuZGktYWkvdml0ZXNzZS1wbGF0Zm9ybS9wcm90by9nZW4vZ28vdml0ZXNzZS92MTt2aXRlc3NldjGiAgNWWFiqAgpWaXRlc3NlLlYxygIKVml0ZXNzZVxWMeICFlZpdGVzc2VcVjFcR1BCTWV0YWRhdGHqAgtWaXRlc3NlOjpWMWIGcHJvdG8z");
/**
 * Describes the message vitesse.v1.FormField.
 * Use `create(FormFieldSchema)` to create a new message.
 */
export const FormFieldSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_form, 0);
/**
 * Describes the message vitesse.v1.FormSchema.
 * Use `create(FormSchemaSchema)` to create a new message.
 */
export const FormSchemaSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_form, 1);
/**
 * The widget a FormField renders as. The frontend keeps a registry
 * FieldComponent → Lit component; the plugin picks one per field.
 *
 * @generated from enum vitesse.v1.FieldComponent
 */
export var FieldComponent;
(function (FieldComponent) {
    /**
     * invalid; every field must name a component
     *
     * @generated from enum value: FIELD_COMPONENT_UNSPECIFIED = 0;
     */
    FieldComponent[FieldComponent["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * single-line text
     *
     * @generated from enum value: FIELD_COMPONENT_TEXT = 1;
     */
    FieldComponent[FieldComponent["TEXT"] = 1] = "TEXT";
    /**
     * numeric spinner
     *
     * @generated from enum value: FIELD_COMPONENT_NUMBER = 2;
     */
    FieldComponent[FieldComponent["NUMBER"] = 2] = "NUMBER";
    /**
     * dropdown over `options` (e.g. Modbus int16/int32/…)
     *
     * @generated from enum value: FIELD_COMPONENT_SELECT = 3;
     */
    FieldComponent[FieldComponent["SELECT"] = 3] = "SELECT";
    /**
     * radio group over `options`
     *
     * @generated from enum value: FIELD_COMPONENT_RADIO = 4;
     */
    FieldComponent[FieldComponent["RADIO"] = 4] = "RADIO";
    /**
     * boolean switch
     *
     * @generated from enum value: FIELD_COMPONENT_TOGGLE = 5;
     */
    FieldComponent[FieldComponent["TOGGLE"] = 5] = "TOGGLE";
    /**
     * masked text (passwords)
     *
     * @generated from enum value: FIELD_COMPONENT_SECRET = 6;
     */
    FieldComponent[FieldComponent["SECRET"] = 6] = "SECRET";
    /**
     * MULTI-LINE masked text (certificate / key material) — a single-line control strips the newlines out of a pasted PEM
     *
     * @generated from enum value: FIELD_COMPONENT_PEM = 7;
     */
    FieldComponent[FieldComponent["PEM"] = 7] = "PEM";
})(FieldComponent || (FieldComponent = {}));
/**
 * Describes the enum vitesse.v1.FieldComponent.
 */
export const FieldComponentSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_form, 0);
//# sourceMappingURL=form_pb.js.map